import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { DeleteNewsAPI, GetAllNewsAPI } from "../../../API/NewsAPI";
import CardHeader from "../../../antd/components/CardHeader";
import Loader from "../../../Components/Shared/Loader";
import TableDefault from "../../../Components/Shared/TableDefault";
import useLoading from "../../../Hooks/useLoading";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { NewsModel } from "../../../Models/NewsModel";
import { NewsColumns } from "../../../Static/NewsColumns";

const News = () => {
    const { loading, toggleLoading } = useLoading();
    const [search, setSearch] = useState<string>("");
    const [news, setNews] = useState<NewsModel[]>([]);
    const [total, setTotal] = useState<number>(0);

    const getAllNews = async (page?: number) => {
        try {
            toggleLoading(true);

            let text = search == null || search == "" ? "all" : search;

            await GetAllNewsAPI(page ?? 1, 7, text).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setNews(resp.data.items);
                    setTotal(resp.data.total);
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const deleteNews = async (id: string) => {
        try {
            toggleLoading(true);

            await DeleteNewsAPI(id).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success("Notícia deletada com sucesso!");
                    getAllNews();
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    useEffect(() => {
        getAllNews();
    }, []);

    return (
        <div className='card ml-2 mr-2 mt-4'>
            {loading && <Loader />}
            <CardHeader
                pageName={"Gestão de Notícias"}
                hasPageBefore={false}
            />
            <div className='card-body mt-4'>
                <TableDefault
                    firstColumnIsLink={false}
                    isNews={true}
                    columns={NewsColumns}
                    rows={news}
                    hasHeader={true}
                    hasPagination={true}
                    changePage={getAllNews}
                    lastColumnIsAction={true}
                    total={total}
                    hasEdit={true}
                    hasDelete={true}
                    functionToDelete={deleteNews}
                    linkToEdit={"/managementMenu/news/edit/"}
                />
                <Link to="/managementMenu/news/create" className="btn btn-primary w-100">Criar Notícia</Link>
            </div>
        </div>
    )
}

export default News;